(() => {
  const config = document.querySelector('[data-gift-guide-navigation]');
  if (!config) return;

  const marker = 'gift_guide';
  const pageType = config.dataset.pageType;
  const main = document.getElementById('MainContent');
  const originalTrails = new WeakMap();
  const decoratedLinks = new WeakSet();

  function localUrl(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin ? url : null;
    } catch {
      return null;
    }
  }

  const guide = localUrl(config.dataset.giftGuideUrl);
  const guideRoute = guide?.pathname.match(/^(.*?)\/pages\/([^/]+)\/?$/);
  if (!main || !guideRoute) return;
  const marketPrefix = guideRoute[1];
  const guideHandle = guideRoute[2];
  const withoutTrailingSlash = (path) => path.replace(/\/$/, '');

  function destination(url) {
    if (!url || !url.pathname.startsWith(`${marketPrefix}/`)) return null;
    const path = url.pathname.slice(marketPrefix.length);
    const product = path.match(/^(?:\/collections\/[^/]+)?\/products\/([^/]+)\/?$/);
    if (product) return {type: 'product', handle: product[1]};
    const collection = path.match(/^\/collections\/([^/]+)(?:\/[^/]+)?\/?$/);
    return collection ? {type: 'collection', handle: collection[1]} : null;
  }

  function state() {
    const current = localUrl(window.location.href);
    const route = destination(current);
    return {
      isGuide: pageType === 'page' && withoutTrailingSlash(current.pathname) === withoutTrailingSlash(guide.pathname),
      active: (pageType === 'collection' || pageType === 'product') && route?.type === pageType
        && current.searchParams.get(marker) === guideHandle,
      route,
    };
  }

  function updateTrails(active) {
    document.querySelectorAll('[data-gift-guide-breadcrumbs]').forEach((nav) => {
      const template = nav.nextElementSibling;
      if (!template?.matches('template[data-gift-guide-breadcrumb-template]')) return;
      let original = originalTrails.get(nav);
      if (active && !original?.active) {
        if (!original) {
          original = {children: Array.from(nav.childNodes, (node) => node.cloneNode(true)), active: false};
          originalTrails.set(nav, original);
        }
        nav.replaceChildren(template.content.cloneNode(true));
        original.active = true;
      } else if (!active && original?.active) {
        nav.replaceChildren(...original.children.map((node) => node.cloneNode(true)));
        original.active = false;
      }
    });
  }

  function followsJourney(url, current) {
    const target = destination(url);
    if (!target) return false;
    if (current.isGuide) return true;
    if (!current.active) return false;
    if (current.route.type === 'collection') {
      return target.type === 'product' || target.type === 'collection' && target.handle === current.route.handle;
    }
    // Preserve the journey through variant links, without applying it to recommendations.
    return target.type === 'product' && target.handle === current.route.handle;
  }

  function updateLinks(current) {
    main.querySelectorAll('a[href]').forEach((anchor) => {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const url = localUrl(href);
      if (!url) return;
      if (followsJourney(url, current)) {
        if (url.searchParams.get(marker) !== guideHandle) {
          url.searchParams.set(marker, guideHandle);
          anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          decoratedLinks.add(anchor);
        }
      } else if (decoratedLinks.has(anchor)) {
        if (url.searchParams.get(marker) === guideHandle) {
          url.searchParams.delete(marker);
          anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
        }
        decoratedLinks.delete(anchor);
      }
    });
  }

  function updateForms(current) {
    main.querySelectorAll('form').forEach((form) => {
      const route = destination(localUrl(form.action || window.location.href));
      const enabled = current.active && current.route.type === 'collection'
        && form.method.toLowerCase() === 'get'
        && route?.type === 'collection' && route.handle === current.route.handle;
      const field = form.querySelector('[data-gift-guide-field]');
      if (!enabled) {
        field?.remove();
      } else if (!field) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = marker;
        input.value = guideHandle;
        input.setAttribute('data-gift-guide-field', '');
        form.appendChild(input);
      }
    });
  }

  function refresh() {
    const current = state();
    // Card swatches can navigate without an anchor. Expose the same bounded context.
    if (current.isGuide || current.active && current.route.type === 'collection') {
      main.dataset.giftGuideContext = guideHandle;
    } else {
      delete main.dataset.giftGuideContext;
    }
    updateTrails(current.active);
    updateLinks(current);
    updateForms(current);
  }

  refresh();
  window.addEventListener('pageshow', refresh);
  window.addEventListener('popstate', refresh);
  document.addEventListener('plp:grid-rendered', refresh);
  document.addEventListener('shopify:section:load', refresh);
  // Product cards and filter controls can be replaced independently of the full page.
  new MutationObserver(refresh).observe(main, {childList: true, subtree: true});
})();
